import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import MakeHash from 'make-hash';
import Text from 'components/text/text';
import Badge from 'components/badge';
import {TweenMax, Power3} from 'gsap';
import messages from './messages';

class ProgressArea extends React.Component {
  constructor(props) {
    super(props);
  }

  /**
   * React Lifecycle Hook
   * Invoked once, immediately after the initial rendering occurs.
   *
   * @method  componentDidMount
   */
  componentDidMount() {
    TweenMax.to(this.content, 0.75, {
      'delay': 0.2,
      'y': 0,
      'opacity': 1,
      'ease': Power3.easeOut
    });
  }

  _renderBadges() {
    const { intl } = this.props;

    return this.props.data.map((data, i) => {
      return (
        <li
          key={MakeHash(`${data.type}-${i}`)}
        >
          <Badge
            label={intl.formatMessage(messages[`${data.type}_label`])}
            badgeColor={data.empty ? 'DarkGray' : 'DefaultGreen'}
            icon={data.empty ? 'x' : 'check'}
            size={data.empty ? '' : 'md'}
            fillColor={data.empty ? 'DarkGray' : 'DefaultGreen'}
            strokeColor={data.empty ? 'DarkGray' : 'DefaultGreen'}
          />
        </li>
      );
    });
  }

  render() {
    const { intl } = this.props;
    const badges = this._renderBadges();
    const complete = this.props.data.filter(data => {
      return !data.empty;
    }).length;

    return (
      <aside
        className="infoHighlight infoHighlight_load"
        role="complementary"
        ref={el => { this.content = el; }}
      >
        <div className="infoHighlight-bar">
          <span className="infoHighlight-bar-top"></span>
          <span className="infoHighlight-bar-bottom"></span>
        </div>
        <div className="infoHighlight-info">
          <div className="set">
            <div className="set-hd">
              <Text
                className="mix-txt_uppercase"
                color="DefaultGray"
                tag="h2"
                weight="normal"
              >
                {intl.formatMessage(messages.your_progress_label)}
              </Text>
            </div>
            <div className="set-bd">
              <Text
                className="txt_lgPlus mix-txt_uppercase"
                color="Lightest"
                tag="span"
                type="lg"
                weight="light"
              >
                {intl.formatMessage(messages.your_progress_completion_label, {numComplete: complete})}
              </Text>
            </div>
            <div className="set-bd set-bd_mega">
              <ul className="vList vList_detached">
                {badges}
              </ul>
            </div>
          </div>
        </div>
      </aside>
    );
  }
}

const dataShape = PropTypes.shape({
  'empty': PropTypes.bool,
  'type': PropTypes.oneOf(['bike', 'saddle', 'shoe']).isRequired
});

ProgressArea.propTypes = {
  'data': PropTypes.arrayOf(dataShape).isRequired
};

export default injectIntl(ProgressArea);



// WEBPACK FOOTER //
// ./src/client/pages/body-data/_progress-area.jsx